import * as d3 from "d3";
import {
    colonAnnotation,
    colourScheme,
    createAxis,
    getTimeFormatter,
    addGridlines,
    responsivefy,
    createTooltip,
    inrFormatterV2,
    generateDownloadData,
    contextMenu
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam, checkbox,gridflag) {

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    console.log("checkbox",checkbox)

    // axios.post(url, filterParam).then(response => {
    let data = resData;
    var axisfontsize=chart.axisFontSize + 'px';
    var axisfontcolor=chart.axisFontColor;
    var axislabelfontsize=chart.axisLabelFontSize + 'px';
    var axislabelfontcolor=chart.axisLabelFontColor;
    // Nest the entries by symbol
    var states = d3.nest().key(function (d) {
        return d.dim1_name;
    }).sortKeys(d3.ascending).entries(data)

    console.log(states)

    // Nest the entries by symbol
    var dNest = d3.nest()
        .key(function (d) {
            return d.dim1_name;
        }).sortKeys(d3.ascending)
        .key(function (d) {
            return d.dim3_name;
        })
        .entries(data);
    var legendtext = dNest[0].values.map(function (d) {
        return d.key
    })
    // console.log("legendMetricTooltip",chart.legendMetricTooltip)
    console.log("legendtext", legendtext)

    console.log("value of dNest",dNest)
    console.log("color",colourScheme(chart.colourscheme1))

    const dim4Names = data.map(d => d.dim4_name);
    const firstDim4Name = dim4Names[0];

    dNest.forEach(function (group) {
        group.values.forEach(function (innerGroup) {
            innerGroup.values.forEach(function (d) {
                // console.log("value of before d.dim", d[chart.x1DataFieldName]);

                let dateRegex;

                if(firstDim4Name === "YYYY-MM-DD"){
                    dateRegex = /^\d{4}-\d{2}-\d{2}$/;
                }else{
                    dateRegex = /^\d{4}-\d{2}$/;
                }

                // Check if the format is YYYY-MM (assuming it's a date)
                if (dateRegex.test(d[chart.x1DataFieldName])) {
                    d[chart.x1DataFieldName] = new Date(d[chart.x1DataFieldName]);
                    // console.log("value of d.dim", d[chart.x1DataFieldName]);
                }
                d[chart.y1DataFieldName] = +d[chart.y1DataFieldName];
            });
        });
    });



    let value1;
    let rang;

    switch (chart.x1D3ScaleType) {
        case "linearScale":
            value1 =[0, d3.max(data, d => d[chart.x1DataFieldName])];
            rang = [0, chart.width];
            break;

        case "bandScale":
            value1 = data.map(d => d[chart.x1DataFieldName]);
            rang = [0, chart.width];
            break;

        case "timeScale":
            value1 = d3.extent(data, d => d[chart.x1DataFieldName]);
            rang = [0, chart.width];
            break;

        default:
        // Handle any other cases or provide a default behavior
        // console.error("Invalid x1D3ScaleType:", chart.x1D3ScaleType);
    }

    // console.log("value of chart.x1D3ScaleType", chart.x1D3ScaleType);

    if (value1 && rang) {

        var AxisScaleType = "timeScale";
        var linearScale = "linearScale";

        var x = createAxis(chart.x1D3ScaleType).domain(value1).range(rang);
        // var y = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);
        // var y2 = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);
        var xAxis;
        var yAxis;
        var y2Axis;

        // console.log("firstDim4Name",firstDim4Name)
        var formatTime = getTimeFormatter(firstDim4Name)

        // console.log("formatTime",formatTime)
        if(AxisScaleType == chart.x1D3ScaleType) {
            // Define the axes
            xAxis = d3.axisBottom(x).tickFormat(formatTime);
        }
        else if(linearScale==chart.x1D3ScaleType)
        {
            xAxis = d3.axisBottom(x).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});
        }
        else{
            xAxis = d3.axisBottom(x)
        }




        if (checkbox == false) {
            var div = d3.select(divId)
            div.selectAll("*").remove();

            // Adds the canvas
            div = d3.select(divId).selectAll("svg")
                .data(dNest)
                .enter()
                .append("svg")
                .attr("width", chart.width + chart.margin.right+ chart.margin.left )
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .call(responsivefy)
                .attr("font", "Arial")
                .style("font-size", "14px")
                .append("g")
                .attr("transform",
                    "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                .attr("id", function (d) {
                    // console.log("div ", d.key);
                    return d.key;
                })

            states.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key
                var div = d3.select("#" + CSS.escape(d.key));


                var y = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);
                var y2 = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);

                y.domain([
                    (function() {
                        var minVal = d3.min(d.values, function(d) {
                            return d[chart.y1DataFieldName];
                        });
                        return (minVal < 0) ? minVal : 0;
                    })(),
                    d3.max(d.values, function(d) {
                        return d[chart.y1DataFieldName];
                    })
                ]);

                y2.domain([
                    (function() {
                        var minVal = d3.min(d.values, function(d) {
                            return d[chart.y2DataFieldName];
                        });
                        return (minVal < 0) ? minVal : 0;
                    })(),
                    d3.max(d.values, function(d) {
                        return d[chart.y2DataFieldName]; // Maximum value in the data
                    })
                ]);

                if(AxisScaleType == chart.y1D3ScaleType) {
                    yAxis = d3.axisLeft(y).tickFormat(formatTime);
                }
                else
                {
                    yAxis = d3.axisLeft(y).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});
                }
                y2Axis = d3.axisRight(y2).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});


                if (gridflag === true) {
                    addGridlines(div, x, y, chart);
                }
                // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
                // // Add the div for the tooltip
                // var div1 = d3.select(divId).append("div1").attr("class", "tooltip").style("opacity", 0);

                const tooltip = createTooltip(divId);

                var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

                // Add <defs> and <clipPath> to the SVG
                div.append("defs")
                    .append("clipPath")
                    .attr("id", "clip1")  // Use d.key for the clipPath id
                    .append("rect")
                    .attr("x", 0)
                    .attr("y", -10)
                    .attr("width", chart.width)   // Clip width matches chart width
                    .attr("height", chart.height+10); // Clip height matches chart height

                // Append a group with clipPath applied
                const contentGroup = div.append("g")
                    .attr("class", "content")
                    .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key

                // Add the X Axis
                div.append("g")
                    .attr("class", "x-axis")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(xAxis)
                    .selectAll("text") //style for x axis text
                    .style("text-anchor", "end")
                    .attr("dx", "-0.5em")
                    .attr("dy", "0.5em")
                    .attr('font-size', axisfontsize)
                    .attr('fill', axisfontcolor)
                    .attr("transform", "rotate(-35)");  // Rotate the text by -45 degrees

                //adding axis labels
                div.append("text")
                    .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", axislabelfontsize)
                    .style('fill', axislabelfontcolor)
                    .text(chart.x1AxisDisplayName);

                // Add the Y Axis
                div.append("g")
                    .attr("class", "y-axis")
                    .call(yAxis)
                    .selectAll("text")
                    .attr('font-size',axisfontsize)
                    .attr('fill',axisfontcolor);

                div.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("x", -chart.height/2)
                    .attr("y", 65)
                    .attr("dy", "-8em")
                    .style("text-anchor", "middle")
                    .attr("font-size", axislabelfontsize)
                    .style('fill', axislabelfontcolor)
                    // .style('display', 'none')
                    .text(d.values[0]?.dim7_name || chart.y1AxisDisplayName);

                div.append("g")
                    .append("text")
                    .attr("x", -40)
                    .attr("y", -10)
                    // .attr("dy", "-9em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "1.1em")
                    //  .style("fill",function(d) { return color(d.key) })
                    .text(function (d) {
                        return states.length===1?'':d.key
                    });

                if(chart.y2D3ScaleType=='linearScale') {
                    y2.domain([
                        (function() {
                            var minVal = d3.min(d.values, function(d) {
                                return d[chart.y2DataFieldName];
                            });
                            return (minVal < 0) ? minVal : 0;
                        })(),
                        d3.max(d.values, function(d) {
                            return d[chart.y2DataFieldName]; // Maximum value in the data
                        })
                    ]);
                    div.append("g").attr("class", "y2-axis")
                        .attr("transform", "translate(" + chart.width + ",0)")
                        .call(y2Axis)
                        .selectAll('text')
                        .attr('font-size',axisfontsize)
                        .attr('fill',axisfontcolor)
                    div.append("text")
                        .attr("transform", "rotate(-90)")
                        .attr("x", -chart.height/2)
                        .attr("y", chart.width+chart.margin.right)
                        .attr("dy", "-8em")
                        .style("text-anchor", "middle")
                        .attr("font-size", axislabelfontsize)
                        .style('fill', axislabelfontcolor)
                        // .style('display', 'none')
                        .text(d.values[0]?.dim8_name || chart.y2AxisDisplayName);
                    if (chart.x1D3ScaleType == 'bandScale') {
                        var lines = contentGroup.selectAll(".line1")
                            .data(function (d) {
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line1 " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 2)
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                                    })
                                    .y(d => {
                                        return y(+d[chart.y1DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        console.log(lines)
                        // Add the dots for the tooltip
                        contentGroup.selectAll(".dot")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                            })
                            .attr("cy", function (d) {
                                return y(d[chart.y1DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);

                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName], chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });

                        var line2 = contentGroup.selectAll(".line")
                            .data(function (d) {
                                // console.log('dichh',d.values)
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 3)
                            .style("stroke-dasharray", ("3, 3"))
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                                    })
                                    .y(d => {
                                        return y2(+d[chart.y2DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        console.log(line2)

                        contentGroup.selectAll(".dot1")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot1")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                            })
                            .attr("cy", function (d) {
                                return y2(d[chart.y2DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);
                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y2DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });
                    } else {
                        lines = contentGroup.selectAll(".line1")
                            .data(function (d) {
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line1 " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 2)
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName]);
                                    })
                                    .y(d => {
                                        return y(+d[chart.y1DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        // console.log(lines)
                        // Add the dots for the tooltip
                        contentGroup.selectAll(".dot")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName]);
                            })
                            .attr("cy", function (d) {
                                return y(d[chart.y1DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);
                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });

                        line2 = contentGroup.selectAll(".line")
                            .data(function (d) {
                                // console.log('dichh',d.values)
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 3)
                            .style("stroke-dasharray", ("3, 3"))
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName]);
                                    })
                                    .y(d => {
                                        return y2(+d[chart.y2DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        // console.log(line2)

                        contentGroup.selectAll(".dot1")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot1")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName]);
                            })
                            .attr("cy", function (d) {
                                return y2(d[chart.y2DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);
                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y2DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });
                    }

                    var y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {
                            var horz = chart.width + chart.margin.left+10; // Position legends to the right of the chart
                            var vert = i * 17; // Adjust vertical position based on index
                            return 'translate(' + horz + ',' + vert + ')';
                        });

                    y1legend.append('circle')
                        .attr('cx', 0)
                        .attr('cy', 30) // Adjusting the vertical position relative to the legend item
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                        });

                    y1legend.append('text')
                        .attr('x', 10)
                        .attr('y', 35) // Adjusting the vertical position relative to the legend item
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key.substring(0, 10) + "...";
                        });

                    // Define new data for the additional legends
                    var additionalLegends = [
                        { key: chart.y2AxisDisplayName, type: "dotted" },
                        { key: chart.y1AxisDisplayName, type: "dashed" }
                    ];

// Append SVG elements for the additional legends
                    var additionalLegend = div.selectAll(".additional-legend")
                        .append("svg")
                        .attr('class', 'legend additional-legend')
                        .data(additionalLegends)
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {
                            var horz = chart.width + chart.margin.left + 10; // Position legends to the right of the chart
                            var vert = i * 17; // Adjust vertical position based on index
                            return 'translate(' + horz + ',' + vert + ')';
                        });

                    additionalLegend.append('line')
                        .attr('x1', -20)
                        .attr('y1', -10)
                        .attr('x2', 10)
                        .attr('y2', -10)
                        .style('stroke-dasharray', function (d) {
                            return d.type === 'dotted' ? '2,2' :'';
                        })
                        .style('stroke-width',2)
                        .style('stroke', 'black');

                    additionalLegend.append('text')
                        .attr('x', 12)
                        .attr('y', -5)
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key;
                        });


                } else {
                    if (chart.x1D3ScaleType == 'bandScale') {
                        lines = contentGroup.selectAll(".line1")
                            .data(function (d) {
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line1 " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 2)
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                                    })
                                    .y(d => {
                                        return y(+d[chart.y1DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        // console.log(lines)
                        // Add the dots for the tooltip
                        contentGroup.selectAll(".dot")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                            })
                            .attr("cy", function (d) {
                                return y(d[chart.y1DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);
                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });
                    }
                    lines = contentGroup.selectAll(".line1")
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("path")
                        .attr("class", function (d) {
                            // Add a class based on the line type (you can customize this logic)
                            return "line1 " + d.key.replace(/\s+/g, '');
                        })
                        .style("stroke", function (d) {
                            return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                        })
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName]);
                                })
                                .y(d => {
                                    return y(+d[chart.y1DataFieldName]);
                                });

                            return line(d.values);
                        })
                    // console.log(lines)
                    // Add the dots for the tooltip
                    contentGroup.selectAll(".dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("class","dot")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d[chart.y1DataFieldName]);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                        })
                        .on("mouseover", function(d) {
                            const fontColor = d.dim3_name == ''
                                ? ""
                                : d.dim3_name == ''
                                    ? "red"
                                    : d.dim3_name == ''
                                        ? "orange"
                                        : metric1ColorScale(d.dim3_name);
                            tooltip.onMouseOver(d, this, function(d) {
                                if (chart.x1D3ScaleType == 'timeScale') {
                                    // Tooltip content for time scale
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId);
                                } else if (chart.x1D3ScaleType == 'linearScale') {
                                    // Tooltip content for linear scale
                                    return chart.x1MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.x1DataFieldName],chart.data.menuId) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId);
                                }
                            },fontColor);
                        })
                        .on('mousemove', function(event) {
                            tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                        })
                        .on("mouseout", function() {
                            // Hide the tooltip on mouse out
                            tooltip.onMouseLeave();
                        })
                        .on('contextmenu', function(d) {

                            // Prepare clickedData with both axes' info
                            const clickedData = {
                                [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                dim1_name:[d.dim1_name],
                                dim3_name: [d.dim3_name]               // e.g., "metric1"
                            };
                            console.log("clickedData",clickedData);
                            // Generate the menu with current config and filters
                            const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                            // Show the context menu
                            contextMenu(menuItems).call(this, clickedData);

                            // Prevent default context menu
                            d3.event.preventDefault();
                        });

                    y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {
                            var horz = chart.width + chart.margin.left+10; // Position legends to the right of the chart
                            var vert = i * 17; // Adjust vertical position based on index
                            return 'translate(' + horz + ',' + vert + ')';
                        });

                    y1legend.append('circle')
                        .attr('cx', 0)
                        .attr('cy', 10) // Adjusting the vertical position relative to the legend item
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                        });

                    y1legend.append('text')
                        .attr('x', 10)
                        .attr('y', 15) // Adjusting the vertical position relative to the legend item
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key.substring(0, 10) + "...";
                        });
                }
                var zoomBehaviour = d3.zoom()
                    .scaleExtent([1, 20])  // Define the zoom range (0.5x to 5x zoom)
                    .on("zoom", zoomed);  // Attach the zoom event

                // Apply zoom to the SVG
                contentGroup.insert("rect","circle")
                    .attr("width",chart.width)
                    .attr("height",chart.height)
                    .attr("fill","none")
                    .attr("pointer-events","all")
                    .call(zoomBehaviour);

                function zoomed() {
                    var zoomState = d3.event.transform;
                    // console.log(zoomState);

                    // Rescale the x-axis (time scale or other continuous scale) and y-axis
                    if (chart.x1D3ScaleType !== 'bandScale') {
                        var newXScale = zoomState.rescaleX(x); // Rescale only for continuous scales
                    }

                    var newYScale = zoomState.rescaleY(y);
                    var newY2Scale = zoomState.rescaleY(y2);

                    // console.log("newXScale", newXScale);
                    // console.log("newYScale", newYScale);
                    // console.log("newY2Scale", newY2Scale);

                    // Update the x-axis dynamically with the appropriate scale
                    if (chart.x1D3ScaleType === 'bandScale') {
                        // Manually adjust the scale for bandScale during zoom
                        x.range([0, zoomState.k * chart.width]); // Stretch or shrink based on zoom level
                        div.select('.x-axis').call(d3.axisBottom(x)) .selectAll("text") //style for x axis text
                            .style("text-anchor", "end")
                            .attr("dx", "-0.5em")
                            .attr("dy", "0.5em")
                            .attr('font-size', axisfontsize)
                            .attr('fill', axisfontcolor)
                            .attr("transform", "rotate(-35)");  // Rotate the text by -45 degrees;
                    } else {
                        div.select('.x-axis').call(d3.axisBottom(newXScale).tickFormat(chart.x1D3ScaleType==='linearScale'?(function (d){return inrFormatterV2(d,chart.data.menuId)}): formatTime)) .selectAll("text") //style for x axis text
                            .style("text-anchor", "end")
                            .attr("dx", "-0.5em")
                            .attr("dy", "0.5em")
                            .attr('font-size', axisfontsize)
                            .attr('fill', axisfontcolor)
                            .attr("transform", "rotate(-35)");  // Rotate the text by -45 degrees;
                    }

                    // Update the y and y2 axes
                    div.select('.y-axis').call(d3.axisLeft(newYScale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})).selectAll("text")
                        .attr('font-size', axisfontsize)
                        .attr('fill', axisfontcolor);
                    div.select('.y2-axis').call(d3.axisRight(newY2Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})).selectAll("text")
                        .attr('font-size', axisfontsize)
                        .attr('fill', axisfontcolor);

                    // Update the line path with the new x and y scales
                    contentGroup.selectAll(".line")
                        .attr('d', d => {
                            const path = d3.line()
                                .x(d => {
                                    if (chart.x1D3ScaleType === 'bandScale') {
                                        // Handle band scale
                                        return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                                    } else {
                                        // Handle continuous scale
                                        return newXScale(d[chart.x1DataFieldName]);
                                    }
                                })
                                .y(d => newY2Scale(+d[chart.y2DataFieldName]))(d.values);

                            return path;
                        });

                    // Update the second line path
                    contentGroup.selectAll(".line1")
                        .attr('d', d => {
                            const path = d3.line()
                                .x(d => {
                                    if (chart.x1D3ScaleType === 'bandScale') {
                                        // Handle band scale
                                        return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                                    } else {
                                        // Handle continuous scale
                                        return newXScale(d[chart.x1DataFieldName]);
                                    }
                                })
                                .y(d => newYScale(+d[chart.y1DataFieldName]))(d.values);

                            return path;
                        });

                    // Update the circles (dots) dynamically with the new x and y scales
                    contentGroup.selectAll(".dot")
                        .attr("cx", d => {
                            if (chart.x1D3ScaleType === 'bandScale') {
                                // Center the dots within the band
                                return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                            } else {
                                return newXScale(d[chart.x1DataFieldName]);
                            }
                        })
                        .attr("cy", d => newYScale(d[chart.y1DataFieldName]));

                    contentGroup.selectAll(".dot1")
                        .attr("cx", d => {
                            if (chart.x1D3ScaleType === 'bandScale') {
                                return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                            } else {
                                return newXScale(d[chart.x1DataFieldName]);
                            }
                        })
                        .attr("cy", d => newY2Scale(d[chart.y2DataFieldName]));
                }



            })
            console.log("inside if condition ->>>>>")
        } else { // ----------inside else condition ---->
            console.log("inside else condition --->")
            div = d3.select(divId)
            div.selectAll("*").remove();
            // Adds the canvas
            div = d3.select(divId).selectAll("svg")
                .data(dNest)
                .enter()
                .append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .call(responsivefy)
                .attr("font", "Arial")
                .style("font-size", "14px")
                .append("g")
                .attr("transform",
                    "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                .attr("id", function (d) {
                    // console.log("div ", d.key);
                    return d.key;
                })

            states.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key
                var div = d3.select("#" + CSS.escape(d.key));

                var y = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);
                var y2 = createAxis(chart.y1D3ScaleType).range([chart.height, 0]);

                //  y.domain([0,d3.max(d.values, function(d) { return d[chart.y1DataFieldName] })])
                y.domain([
                    (function() {
                        var minVal = d3.min(d.values, function(d) {
                            return d[chart.y1DataFieldName];
                        });
                        return (minVal < 0) ? minVal : 0;
                    })(),
                    d3.max(d.values, function(d) {
                        return d[chart.y1DataFieldName]; // Maximum value in the data
                    })
                ]);
                y2.domain([
                    (function() {
                        var minVal = d3.min(d.values, function(d) {
                            return d[chart.y2DataFieldName];
                        });
                        return (minVal < 0) ? minVal : 0;
                    })(),
                    d3.max(d.values, function(d) {
                        return d[chart.y2DataFieldName]; // Maximum value in the data
                    })
                ]);

                if(AxisScaleType == chart.y1D3ScaleType) {
                    yAxis = d3.axisLeft(y).tickFormat(formatTime);
                }
                else
                {
                    yAxis = d3.axisLeft(y).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});
                }
                y2Axis = d3.axisRight(y2).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});

                // Add the div for the tooltip
                // var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);
                const tooltip1 = createTooltip(divId)
                var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)
                if (gridflag === true) {
                    addGridlines(div, x, y, chart);
                }
                // Add the div for the tooltip
                //  div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);

                metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

                // Add <defs> and <clipPath> to the SVG
                div.append("defs")
                    .append("svg:clipPath")
                    .attr("id", "clip1")  // Use d.key for the clipPath id
                    .append("svg:rect")
                    .attr("x", 0)
                    .attr("y", -10)
                    .attr("width", chart.width)   // Clip width matches chart width
                    .attr("height", chart.height+10); // Clip height matches chart height

                // Append a group with clipPath applied
                const contentGroup = div.append("g")
                    .attr("class", "content")
                    .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key

                // Add the X Axis
                div.append("g")
                    .attr("class", "x-axis")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(xAxis)
                    .selectAll("text") //style for x axis text
                    .style("text-anchor", "end")
                    .attr("dx", "-0.5em")
                    .attr("dy", "0.5em")
                    .attr('font-size',axisfontsize)
                    .attr('fill',axisfontcolor)
                    .attr("transform", "rotate(-35)");  // Rotate the text by -45 degrees

                //adding axis labels
                div.append("text")
                    .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", axislabelfontsize)
                    .style('fill', axislabelfontcolor)
                    .text(chart.x1AxisDisplayName);

                // Add the Y Axis
                div.append("g").attr("class", "y-axis").call(yAxis)
                    .selectAll('text')
                    .attr('font-size',axisfontsize)
                    .attr('fill',axisfontcolor);

                div.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("x", -chart.height/2)
                    .attr("y", 65)
                    .attr("dy", "-8em")
                    .style("text-anchor", "middle")
                    .attr("font-size", axislabelfontsize)
                    .style('fill', axislabelfontcolor)
                    // .style('display', 'none')
                    .text(d.values[0]?.dim7_name || chart.y1AxisDisplayName);

                div.append("g")
                    .append("text")
                    .attr("x", -40)
                    .attr("y", -10)
                    // .attr("dy", "-9em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "1.1em")
                    //  .style("fill",function(d) { return color(d.key) })
                    .text(function (d) {
                        return d.key
                    });

                if(chart.y2D3ScaleType=='linearScale') {
                    div.append("g").attr("class", "y2 axis")
                        .attr("transform", "translate(" + chart.width + ",0)")
                        .call(y2Axis)
                        .selectAll('text')
                        .attr('font-size',axisfontsize)
                        .attr('fill',axisfontcolor)
                    div.append("text")
                        .attr("transform", "rotate(-90)")
                        .attr("x", -chart.height/2)
                        .attr("y", chart.width+chart.margin.right)
                        .attr("dy", "-8em")
                        .style("text-anchor", "middle")
                        .attr("font-size",axislabelfontsize)
                        .style('fill', axislabelfontcolor)
                        // .style('display', 'none')
                        .text(d.values[0]?.dim8_name || chart.y2AxisDisplayName);
                    if (chart.x1D3ScaleType == 'bandScale') {
                        var lines = contentGroup.selectAll(".line1")
                            .data(function (d) {
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line1 " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 2)
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                                    })
                                    .y(d => {
                                        return y(+d[chart.y1DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        console.log(lines)
                        // Add the dots for the tooltip
                        contentGroup.selectAll(".dot")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                            })
                            .attr("cy", function (d) {
                                return y(d[chart.y1DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);

                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip1.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName], chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip1.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });

                        var line2 = contentGroup.selectAll(".line")
                            .data(function (d) {
                                // console.log('dichh',d.values)
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 3)
                            .style("stroke-dasharray", ("3, 3"))
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                                    })
                                    .y(d => {
                                        return y2(+d[chart.y2DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        console.log(line2)

                        contentGroup.selectAll(".dot1")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot1")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                            })
                            .attr("cy", function (d) {
                                return y2(d[chart.y2DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);

                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip1.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + d[chart.x1DataFieldName] + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y2DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip1.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });
                    } else {
                        lines = contentGroup.selectAll(".line1")
                            .data(function (d) {
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line1 " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 2)
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName]);
                                    })
                                    .y(d => {
                                        return y(+d[chart.y1DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        // console.log(lines)
                        // Add the dots for the tooltip
                        contentGroup.selectAll(".dot")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName]);
                            })
                            .attr("cy", function (d) {
                                return y(d[chart.y1DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);

                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip1.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip1.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });

                        line2 = contentGroup.selectAll(".line")
                            .data(function (d) {
                                // console.log('dichh',d.values)
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 3)
                            .style("stroke-dasharray", ("3, 3"))
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName]);
                                    })
                                    .y(d => {
                                        return y2(+d[chart.y2DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        // console.log(line2)

                        contentGroup.selectAll(".dot1")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot1")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName]);
                            })
                            .attr("cy", function (d) {
                                return y2(d[chart.y2DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);

                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip1.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.legendMetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y2DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip1.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });
                    }
                    var y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {
                            var horz = chart.width + chart.margin.left+10; // Position legends to the right of the chart
                            var vert = i * 17; // Adjust vertical position based on index
                            return 'translate(' + horz + ',' + vert + ')';
                        });

                    y1legend.append('circle')
                        .attr('cx', 0)
                        .attr('cy', 30) // Adjusting the vertical position relative to the legend item
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                        });

                    y1legend.append('text')
                        .attr('x', 10)
                        .attr('y', 35) // Adjusting the vertical position relative to the legend item
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key.substring(0, 10) + "...";
                        });

                    // Define new data for the additional legends
                    var additionalLegends = [
                        { key: chart.y2AxisDisplayName, type: "dotted" },
                        { key: chart.y1AxisDisplayName, type: "dashed" }
                    ];

// Append SVG elements for the additional legends
                    var additionalLegend = div.selectAll(".additional-legend")
                        .append("svg")
                        .attr('class', 'legend additional-legend')
                        .data(additionalLegends)
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {
                            var horz = chart.width + chart.margin.left + 10; // Position legends to the right of the chart
                            var vert = i * 17; // Adjust vertical position based on index
                            return 'translate(' + horz + ',' + vert + ')';
                        });

                    additionalLegend.append('line')
                        .attr('x1', -20)
                        .attr('y1', -10)
                        .attr('x2', 10)
                        .attr('y2', -10)
                        .style('stroke-dasharray', function (d) {
                            return d.type === 'dotted' ? '2,2' :'';
                        })
                        .style('stroke-width',2)
                        .style('stroke', 'black');

                    additionalLegend.append('text')
                        .attr('x', 12)
                        .attr('y', -5)
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key;
                        });

                } else {
                    if (chart.x1D3ScaleType == 'bandScale') {
                        lines = contentGroup.selectAll(".line1")
                            .data(function (d) {
                                return d.values;
                            })
                            .enter()
                            .append("path")
                            .attr("class", function (d) {
                                // Add a class based on the line type (you can customize this logic)
                                return "line1 " + d.key.replace(/\s+/g, '');
                            })
                            .style("stroke", function (d) {
                                return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                            })
                            .attr("stroke-width", 2)
                            .attr("fill", "none")
                            .attr('d', (d) => {
                                let line = d3.line()
                                    .x(d => {
                                        return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                                    })
                                    .y(d => {
                                        return y(+d[chart.y1DataFieldName]);
                                    });

                                return line(d.values);
                            })
                        // console.log(lines)
                        // Add the dots for the tooltip
                        contentGroup.selectAll(".dot")
                            .data(function () {
                                return d.values
                            })
                            .enter().append("circle")
                            .attr("class","dot")
                            .attr("r", 5)
                            .attr("cx", function (d) {
                                return x(d[chart.x1DataFieldName])+x.bandwidth()/2;
                            })
                            .attr("cy", function (d) {
                                return y(d[chart.y1DataFieldName]);
                            })
                            .style("fill", function (d) {
                                return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                            })
                            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                            .on("mouseover", function(d) {
                                const fontColor = d.dim3_name == ''
                                    ? ""
                                    : d.dim3_name == ''
                                        ? "red"
                                        : d.dim3_name == ''
                                            ? "orange"
                                            : metric1ColorScale(d.dim3_name);

                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip1.onMouseOver(d, this, function(d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)
                                },fontColor);
                            })
                            .on('mousemove', function(event) {
                                tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                            })
                            .on("mouseout", function() {
                                // Hide the tooltip on mouse out
                                tooltip1.onMouseLeave();
                            })
                            .on('contextmenu', function(d) {

                                // Prepare clickedData with both axes' info
                                const clickedData = {
                                    [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                    dim1_name:[d.dim1_name],
                                    dim3_name: [d.dim3_name]               // e.g., "metric1"
                                };
                                console.log("clickedData",clickedData);
                                // Generate the menu with current config and filters
                                const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                                // Show the context menu
                                contextMenu(menuItems).call(this, clickedData);

                                // Prevent default context menu
                                d3.event.preventDefault();
                            });
                    }
                    lines = contentGroup.selectAll(".line1")
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("path")
                        .attr("class", function (d) {
                            // Add a class based on the line type (you can customize this logic)
                            return "line1 " + d.key.replace(/\s+/g, '');
                        })
                        .style("stroke", function (d) {
                            return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                        })
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName]);
                                })
                                .y(d => {
                                    return y(+d[chart.y1DataFieldName]);
                                });

                            return line(d.values);
                        })
                    // console.log(lines)
                    // Add the dots for the tooltip
                    contentGroup.selectAll(".dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("class","dot")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d[chart.y1DataFieldName]);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == '' ? "" : d.dim3_name == '' ? "red" : d.dim3_name == '' ? "orange" : metric1ColorScale(d.dim3_name);
                        })
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function(d) {
                            const fontColor = d.dim3_name == ''
                                ? ""
                                : d.dim3_name == ''
                                    ? "red"
                                    : d.dim3_name == ''
                                        ? "orange"
                                        : metric1ColorScale(d.dim3_name);
                            if(chart.x1D3ScaleType=='timeScale') {
                                // console.log(d3.event, d); // For debugging, log the event and data
                                tooltip1.onMouseOver(d, this, function (d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + formatTime(d[chart.x1DataFieldName]) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)
                                }, fontColor);
                            }else if(chart.x1D3ScaleType=='linearScale'){
                                tooltip1.onMouseOver(d, this, function (d) {
                                    // Tooltip content callback
                                    return chart.x1MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.x1DataFieldName],chart.data.menuId) + "<br/>" +
                                        chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                        chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d[chart.y1DataFieldName],chart.data.menuId)
                                }, fontColor);
                            }
                        })
                        .on('mousemove', function(event) {
                            tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                        })
                        .on("mouseout", function() {
                            // Hide the tooltip on mouse out
                            tooltip1.onMouseLeave();
                        })
                        .on('contextmenu', function(d) {

                            // Prepare clickedData with both axes' info
                            const clickedData = {
                                [chart.x1DataFieldName]:[d[chart.x1DataFieldName]],
                                dim1_name:[d.dim1_name],
                                dim3_name: [d.dim3_name]               // e.g., "metric1"
                            };
                            console.log("clickedData",clickedData);
                            // Generate the menu with current config and filters
                            const menuItems = generateDownloadData(chart.insightNavigator, filterParam);

                            // Show the context menu
                            contextMenu(menuItems).call(this, clickedData);

                            // Prevent default context menu
                            d3.event.preventDefault();
                        });
                    y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {
                            var horz = chart.width + chart.margin.left+10; // Position legends to the right of the chart
                            var vert = i * 17; // Adjust vertical position based on index
                            return 'translate(' + horz + ',' + vert + ')';
                        });

                    y1legend.append('circle')
                        .attr('cx', 0)
                        .attr('cy', 20) // Adjusting the vertical position relative to the legend item
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == '' ? "" : d.key == '' ? "red" : d.key == '' ? "orange" : metric1ColorScale(d.key);
                        });

                    y1legend.append('text')
                        .attr('x', 10)
                        .attr('y', 25) // Adjusting the vertical position relative to the legend item
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key.substring(0, 10) + "...";
                        });

                }
                var zoomBehaviour = d3.zoom()
                    .scaleExtent([1, 20])  // Define the zoom range (0.5x to 5x zoom)
                    .on("zoom", zoomed);  // Attach the zoom event

                // Apply zoom to the SVG
                contentGroup.insert("rect","circle")
                    .attr("width",chart.width)
                    .attr("height",chart.height)
                    .attr("fill","none")
                    .attr("pointer-events","all")
                    .call(zoomBehaviour);

                function zoomed() {
                    var zoomState = d3.event.transform;
                    // console.log(zoomState);

                    // Rescale the x-axis (time scale or other continuous scale) and y-axis
                    if (chart.x1D3ScaleType !== 'bandScale') {
                        var newXScale = zoomState.rescaleX(x); // Rescale only for continuous scales
                    }

                    var newYScale = zoomState.rescaleY(y);
                    // console.log("newYScale",newYScale.domain());
                    var newY2Scale = zoomState.rescaleY(y2);

                    // Update the x-axis dynamically with the appropriate scale
                    if (chart.x1D3ScaleType === 'bandScale') {
                        // Manually adjust the scale for bandScale during zoom
                        x.range([0, zoomState.k * chart.width]); // Stretch or shrink based on zoom level
                        div.select('.x-axis').call(d3.axisBottom(x)) .selectAll("text") //style for x axis text
                            .style("text-anchor", "end")
                            .attr("dx", "-0.5em")
                            .attr("dy", "0.5em")
                            .attr('font-size', axisfontsize)
                            .attr('fill', axisfontcolor)
                            .attr("transform", "rotate(-35)");  // Rotate the text by -45 degrees;
                    } else {
                        div.select('.x-axis').call(d3.axisBottom(newXScale).tickFormat(chart.x1D3ScaleType==='linearScale'?(function (d){return inrFormatterV2(d,chart.data.menuId)}): formatTime)) .selectAll("text") //style for x axis text
                            .style("text-anchor", "end")
                            .attr("dx", "-0.5em")
                            .attr("dy", "0.5em")
                            .attr('font-size', axisfontsize)
                            .attr('fill', axisfontcolor)
                            .attr("transform", "rotate(-35)");  // Rotate the text by -45 degrees;
                    }

                    // Update the y and y2 axes
                    div.select('.y-axis').call(d3.axisLeft(newYScale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})).selectAll("text")
                        .attr('font-size', axisfontsize)
                        .attr('fill', axisfontcolor);
                    div.select('.y2-axis').call(d3.axisRight(newY2Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})).selectAll("text")
                        .attr('font-size', axisfontsize)
                        .attr('fill', axisfontcolor);

                    // Update the line path with the new x and y scales
                    contentGroup.selectAll(".line")
                        .attr('d', d => {
                            const path = d3.line()
                                .x(d => {
                                    if (chart.x1D3ScaleType === 'bandScale') {
                                        // Handle band scale
                                        return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                                    } else {
                                        // Handle continuous scale
                                        return newXScale(d[chart.x1DataFieldName]);
                                    }
                                })
                                .y(d => newY2Scale(+d[chart.y2DataFieldName]))(d.values);

                            return path;
                        });

                    // Update the second line path
                    contentGroup.selectAll(".line1")
                        .attr('d', d => {
                            const path = d3.line()
                                .x(d => {
                                    if (chart.x1D3ScaleType === 'bandScale') {
                                        // Handle band scale
                                        return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                                    } else {
                                        // Handle continuous scale
                                        return newXScale(d[chart.x1DataFieldName]);
                                    }
                                })
                                .y(d => newYScale(+d[chart.y1DataFieldName]))(d.values);

                            return path;
                        });

                    // Update the circles (dots) dynamically with the new x and y scales
                    contentGroup.selectAll(".dot")
                        .attr("cx", d => {
                            if (chart.x1D3ScaleType === 'bandScale') {
                                // Center the dots within the band
                                return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                            } else {
                                return newXScale(d[chart.x1DataFieldName]);
                            }
                        })
                        .attr("cy", d => newYScale(d[chart.y1DataFieldName]));

                    contentGroup.selectAll(".dot1")
                        .attr("cx", d => {
                            if (chart.x1D3ScaleType === 'bandScale') {
                                return x(d[chart.x1DataFieldName]) + x.bandwidth() / 2;
                            } else {
                                return newXScale(d[chart.x1DataFieldName]);
                            }
                        })
                        .attr("cy", d => newY2Scale(d[chart.y2DataFieldName]));
                }
            })
        }
    }
    // })
}
